import angular from 'angular';
import insuranceFileDropdown from './insuranceFileDropdown';

export default angular
  .module('components.insuranceFileDropdown', [])
  .component('insuranceFileDropdown', insuranceFileDropdown).name;
